import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './Pages/Home';
import ServicesResidentialCommercial from './Pages/ServicesResidentialCommercial';
import ServicesIndustrialMechanical from './Pages/ServicesIndustrialMechanical';
import ServicesManagement from './Pages/ServicesManagement';
import Error from './Pages/Error';

import ScrollToTop from './Common/ScrollToTop';

const Components = () => (
  <BrowserRouter basename="/">
    <ScrollToTop />
    <a className="skip-link" href="#main">
      Skip to content
    </a>
    <div className="page-wraper">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/servicesManagement" element={<ServicesManagement />} />
        <Route
          path="/servicesResidentialCommercial"
          element={<ServicesResidentialCommercial />}
        />
        <Route
          path="/servicesIndustrialMechanical"
          element={<ServicesIndustrialMechanical />}
        />
        {/* Previously had no `path`, so it never matched and 404s rendered blank */}
        <Route path="*" element={<Error />} />
      </Routes>
    </div>
  </BrowserRouter>
);

export default Components;
